import React, {Component} from 'react'

class FadingImage extends Component {

    static propTypes = {}

    constructor(props) {
        super(props)

        this.state = {
            imageLoaded: false
        }

    }

    handleImageLoaded = (e) => {

        this.setState({
            imageLoaded: true
        })

    }

    render() {

        const className = (this.props.className ? this.props.className : '') + (this.state.imageLoaded ? ' fd-img' : ' fd-img fd-img--loading')

        return (
            <img {...this.props} role="presentation" onLoad={this.handleImageLoaded} className={className}/>
        )

    }

}

export default FadingImage



/** WEBPACK FOOTER **
 ** ./src/components/FadingImage.js
 **/